var map = {
	"./campaigns/ActiveLifestyleCarrefour": "9cdd",
	"./campaigns/ActiveLifestyleCarrefour.js": "9cdd",
	"./campaigns/ActiveLifestyleCora": "4413",
	"./campaigns/ActiveLifestyleCora.js": "4413",
	"./campaigns/ActiveLifestyleMega": "f418",
	"./campaigns/ActiveLifestyleMega.js": "f418",
	"./campaigns/AjaxAxion2023": "cfaa",
	"./campaigns/AjaxAxion2023.js": "cfaa",
	"./campaigns/Auchan2022": "c177",
	"./campaigns/Auchan2022.js": "c177",
	"./campaigns/AutumnCleaning2022": "fead",
	"./campaigns/AutumnCleaning2022.js": "fead",
	"./campaigns/Autumncleaning2023": "dab4",
	"./campaigns/Autumncleaning2023.js": "dab4",
	"./campaigns/Carrefour2022": "54d6",
	"./campaigns/Carrefour2022.js": "54d6",
	"./campaigns/CarrefourAniversar2024": "1281",
	"./campaigns/CarrefourAniversar2024.js": "1281",
	"./campaigns/CarrefourAniversar2025": "a8f3",
	"./campaigns/CarrefourAniversar2025.js": "a8f3",
	"./campaigns/ColgateAugust2022": "d52d",
	"./campaigns/ColgateAugust2022.js": "d52d",
	"./campaigns/ColgateCarrefour21Ani": "db6b",
	"./campaigns/ColgateCarrefour21Ani.js": "db6b",
	"./campaigns/ColgateCharcoal": "416a",
	"./campaigns/ColgateCharcoal.js": "416a",
	"./campaigns/ColgateElixirCarrefour2022": "59af",
	"./campaigns/ColgateElixirCarrefour2022.js": "59af",
	"./campaigns/ColgateEquityCarrefourJan2022": "8eb6",
	"./campaigns/ColgateEquityCarrefourJan2022.js": "8eb6",
	"./campaigns/ColgateIT": "a529",
	"./campaigns/ColgateIT.js": "a529",
	"./campaigns/ColgateKaufland2025": "b23c",
	"./campaigns/ColgateKaufland2025.js": "b23c",
	"./campaigns/ColgateLLDP2025": "e903",
	"./campaigns/ColgateLLDP2025.js": "e903",
	"./campaigns/ColgateLidl2025": "910c",
	"./campaigns/ColgateLidl2025.js": "910c",
	"./campaigns/ColgateMax2023": "0891",
	"./campaigns/ColgateMax2023.js": "0891",
	"./campaigns/ColgateMaxAuchan2023": "a58d",
	"./campaigns/ColgateMaxAuchan2023.js": "a58d",
	"./campaigns/ColgateOHM2024": "e9ea",
	"./campaigns/ColgateOHM2024.js": "e9ea",
	"./campaigns/ColgateOHMLDP2024": "6ac7",
	"./campaigns/ColgateOHMLDP2024.js": "6ac7",
	"./campaigns/ColgatePalmolive2023": "d950",
	"./campaigns/ColgatePalmolive2023.js": "d950",
	"./campaigns/ColgateSeptember2023": "9452",
	"./campaigns/ColgateSeptember2023.js": "9452",
	"./campaigns/ColgateSummer2023": "5254",
	"./campaigns/ColgateSummer2023.js": "5254",
	"./campaigns/ColgateSummerKaufland2023": "9229",
	"./campaigns/ColgateSummerKaufland2023.js": "9229",
	"./campaigns/ColgateTotal2023": "ddb1",
	"./campaigns/ColgateTotal2023.js": "ddb1",
	"./campaigns/ColgateTotal2024": "1ae9",
	"./campaigns/ColgateTotal2024.js": "1ae9",
	"./campaigns/ColgateTotal2025": "e320",
	"./campaigns/ColgateTotal2025.js": "e320",
	"./campaigns/ColgateTotalActivePrevention2025": "9aa8",
	"./campaigns/ColgateTotalActivePrevention2025.js": "9aa8",
	"./campaigns/ColgateTotalCarrefour2022": "c528",
	"./campaigns/ColgateTotalCarrefour2022.js": "c528",
	"./campaigns/ColgateTotalDM2022": "760a",
	"./campaigns/ColgateTotalDM2022.js": "760a",
	"./campaigns/ColgateTotalFraud2024": "95dc",
	"./campaigns/ColgateTotalFraud2024.js": "95dc",
	"./campaigns/ColgateTotalMegaImage2022": "96a8",
	"./campaigns/ColgateTotalMegaImage2022.js": "96a8",
	"./campaigns/ColgateUltra2023": "c58c",
	"./campaigns/ColgateUltra2023.js": "c58c",
	"./campaigns/ColgateWhite2025": "bf58",
	"./campaigns/ColgateWhite2025.js": "bf58",
	"./campaigns/ColgateWhiteMoneyBack2024": "6894",
	"./campaigns/ColgateWhiteMoneyBack2024.js": "6894",
	"./campaigns/ColgateWhiteMoneyBack2025": "d30f",
	"./campaigns/ColgateWhiteMoneyBack2025.js": "d30f",
	"./campaigns/ColgateWhitening2023": "81a3",
	"./campaigns/ColgateWhitening2023.js": "81a3",
	"./campaigns/ColgateWhitening2024": "74ea",
	"./campaigns/ColgateWhitening2024.js": "74ea",
	"./campaigns/ColgateWhiteningAuchan2022": "3385",
	"./campaigns/ColgateWhiteningAuchan2022.js": "3385",
	"./campaigns/ColgateWhiteningCarrefour2022": "2e5d",
	"./campaigns/ColgateWhiteningCarrefour2022.js": "2e5d",
	"./campaigns/ColgateWhiteningSelgros2024": "fd25",
	"./campaigns/ColgateWhiteningSelgros2024.js": "fd25",
	"./campaigns/ColgateWomenDay2024": "13af",
	"./campaigns/ColgateWomenDay2024.js": "13af",
	"./campaigns/ColgateWomenDay2025": "c922",
	"./campaigns/ColgateWomenDay2025.js": "c922",
	"./campaigns/Elmex-MB2023": "b3b2",
	"./campaigns/Elmex-MB2023.js": "b3b2",
	"./campaigns/Elmex2023": "312f",
	"./campaigns/Elmex2023.js": "312f",
	"./campaigns/ElmexAuchanFeb2022": "b752",
	"./campaigns/ElmexAuchanFeb2022.js": "b752",
	"./campaigns/ElmexAugust2022": "bbb6",
	"./campaigns/ElmexAugust2022.js": "bbb6",
	"./campaigns/ElmexCarrefourFeb2022": "c074",
	"./campaigns/ElmexCarrefourFeb2022.js": "c074",
	"./campaigns/ElmexCarrefourJuly2022": "1f58",
	"./campaigns/ElmexCarrefourJuly2022.js": "1f58",
	"./campaigns/ElmexIT2023": "ff35",
	"./campaigns/ElmexIT2023.js": "ff35",
	"./campaigns/ElmexMegaFeb2022": "dd44",
	"./campaigns/ElmexMegaFeb2022.js": "dd44",
	"./campaigns/ElmexMoneyBack2024": "735c",
	"./campaigns/ElmexMoneyBack2024.js": "735c",
	"./campaigns/ElmexMoneyBack2025": "47e4",
	"./campaigns/ElmexMoneyBack2025.js": "47e4",
	"./campaigns/IngrijirePersonalaKaufland2025": "8fb0",
	"./campaigns/IngrijirePersonalaKaufland2025.js": "8fb0",
	"./campaigns/Ladyspeedstick2023": "1976",
	"./campaigns/Ladyspeedstick2023.js": "1976",
	"./campaigns/LidlBeauty2025": "6a95",
	"./campaigns/LidlBeauty2025.js": "6a95",
	"./campaigns/MegaImage2022": "fabc",
	"./campaigns/MegaImage2022.js": "fabc",
	"./campaigns/Moneyback2022": "e1dd",
	"./campaigns/Moneyback2022.js": "e1dd",
	"./campaigns/Palmolive2023": "db5e",
	"./campaigns/Palmolive2023.js": "db5e",
	"./campaigns/PalmoliveCarrefourJune2022": "ba57",
	"./campaigns/PalmoliveCarrefourJune2022.js": "ba57",
	"./campaigns/PalmoliveChristmas2024": "3a0f",
	"./campaigns/PalmoliveChristmas2024.js": "3a0f",
	"./campaigns/PalmoliveExperentials2023": "a1f4",
	"./campaigns/PalmoliveExperentials2023.js": "a1f4",
	"./campaigns/PalmoliveLifestyle2024": "5b96",
	"./campaigns/PalmoliveLifestyle2024.js": "5b96",
	"./campaigns/PalmoliveSmoothies2022": "57fa",
	"./campaigns/PalmoliveSmoothies2022.js": "57fa",
	"./campaigns/PalmoliveSummer2023": "a73f",
	"./campaigns/PalmoliveSummer2023.js": "a73f",
	"./campaigns/Protex2023": "5dd3",
	"./campaigns/Protex2023.js": "5dd3",
	"./campaigns/Protex2024": "cb23",
	"./campaigns/Protex2024.js": "cb23",
	"./campaigns/ProtexCarrefour": "8618",
	"./campaigns/ProtexCarrefour.js": "8618",
	"./campaigns/ProtexCarrefourJan2022": "507c",
	"./campaigns/ProtexCarrefourJan2022.js": "507c",
	"./campaigns/ProtexCharcoalCarrefour2022": "172c",
	"./campaigns/ProtexCharcoalCarrefour2022.js": "172c",
	"./campaigns/ProtexCharcoalCora2022": "0bc7",
	"./campaigns/ProtexCharcoalCora2022.js": "0bc7",
	"./campaigns/ProtexCharcoalMega2022": "8c35",
	"./campaigns/ProtexCharcoalMega2022.js": "8c35",
	"./campaigns/ProtexHealthProtection2023": "3727",
	"./campaigns/ProtexHealthProtection2023.js": "3727",
	"./campaigns/ProtexSummerCarrefour2022": "8eb4",
	"./campaigns/ProtexSummerCarrefour2022.js": "8eb4",
	"./campaigns/ProtexSummerRomania": "746e",
	"./campaigns/ProtexSummerRomania.js": "746e",
	"./campaigns/Protexcashback2025": "1158",
	"./campaigns/Protexcashback2025.js": "1158",
	"./campaigns/SpringCleaning2025": "17f8",
	"./campaigns/SpringCleaning2025.js": "17f8",
	"./campaigns/SpringCleaningCarrefour2022": "7b3e",
	"./campaigns/SpringCleaningCarrefour2022.js": "7b3e",
	"./campaigns/SpringCleaningCora2022": "ffe5",
	"./campaigns/SpringCleaningCora2022.js": "ffe5",
	"./campaigns/SpringCleaningMega2022": "4ff5",
	"./campaigns/SpringCleaningMega2022.js": "4ff5",
	"./campaigns/Springcleaning2024": "a63b",
	"./campaigns/Springcleaning2024.js": "a63b",
	"./campaigns/SummerExperience2024": "d998",
	"./campaigns/SummerExperience2024.js": "d998",
	"./campaigns/SummerJoy2025": "a2dc",
	"./campaigns/SummerJoy2025.js": "a2dc",
	"./campaigns/WomenDay2024": "7de7",
	"./campaigns/WomenDay2024.js": "7de7",
	"./campaigns/WomenDay2025": "aba8",
	"./campaigns/WomenDay2025.js": "aba8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ffa";